define('responsive-gameday/controllers/WrapupViewController',['require','exports','module','Responsive/controllers/ScrollViewController','../views/render/WrapupViewRender','message-service/message-service','../views/Monitor/Events/ViewModelUpdateEvents','image-loader/image-loader','gameday-index-url-hasher/enums/HashEvents','responsive-gameday-tracking/responsive-gameday-tracking','Responsive/util/renderComplete','swiper/dist/js/swiper','jquery','FitText.js/jquery.fittext'],function(require,exports,module){
	var ScrollViewController = require( 'Responsive/controllers/ScrollViewController' ),
		WrapupViewRender =	require( '../views/render/WrapupViewRender' ),
		MessageService = require("message-service/message-service"),
        VMEvents = require("../views/Monitor/Events/ViewModelUpdateEvents"),
        imageLoader = require( 'image-loader/image-loader' ),
        HashEvents = require("gameday-index-url-hasher/enums/HashEvents"),
        Tracking = require("responsive-gameday-tracking/responsive-gameday-tracking"),
        renderComplete = require( 'Responsive/util/renderComplete' ),
		Swiper = require('swiper/dist/js/swiper'),
		$ = require('jquery'),
        fitText = require('FitText.js/jquery.fittext');


	// Add private variables here
	var Superclass;

	// Add private methods here

	function onBeat(data, evt) {
		var that = this,
			compiledData = data || {};

			that.childWrapper.innerHTML = that.viewRender.render(compiledData);

		renderComplete(function () {
			that.hideOverlay();
			var mySwiper = new Swiper('.swiper-container', {		    
			    // If we need pagination
			    pagination: '.swiper-pagination',
			    paginationHide: false,
			    slidesPerView : 3.0,
			    slidesPerGroup : 3.0,
			    paginationClickable: true,
			    spaceBetween : 15,
			    
			    // Navigation arrows
			    nextButton: '.swiper-button-next',
			    prevButton: '.swiper-button-prev'
			});

			jQuery('.recap-header-title').fitText(0.55,{
				minFontSize:24,
				maxFontSize:60
			});

			$(".video-highlights").addClass("is-hidden");
			// Refresh the scroll control when we know the image is done loading
			$.whenAlways((compiledData.recap && compiledData.recap.game && compiledData.recap.game.photo && imageLoader.load(compiledData.recap.game.photo))).always(function () {
				that.setScroll();
			});
		});
	}

	// Constructor
	function WrapupViewController(type) {
		// Call super constructor
		Superclass.constructor.call(this);
		this.viewRender = new WrapupViewRender();
		this.inningCount = 0;
		this.location = 0;
		this.tabTitle = "Wrapup";
		this.onBeat=function(payload, evt) {
            onBeat.call(this,payload,evt);
        };
	}

	// Prototype Inheritence
	ScrollViewController.spawn(WrapupViewController).define({
		loadView: function () {
			var that = this;
			Superclass.loadView.call(this);
			this.showOverlay();
			this.setScrollOpts({horizontal:false});
			this.setClassName("WrapupViewController");
		},
		viewWillAppear: function () {
			MessageService.addListener.call(this, VMEvents.UPDATE_WRAPUP, this.onBeat);
			Superclass.viewWillAppear.call(this);
			Tracking.track_wrapup_tab_launch();
		},
		viewWillDisappear: function () {
			MessageService.removeListener(VMEvents.UPDATE_WRAPUP, this.onBeat);
			Superclass.viewWillDisappear.call(this);
			$(".video-highlights").removeClass("is-hidden");
		},
		viewDidAppear: function() {
			Superclass.viewDidAppear.call(this);
			MessageService.publish(VMEvents.REQUEST_WRAPUP_DATA);
		}
	});

	Superclass = WrapupViewController.superclass;
	return WrapupViewController;
});
